import { Button, Caption, Paragraph } from '@mediahuis/chameleon-react';
import React, { useEffect, useRef } from 'react';
import { t } from 'i18next';
import { useBrandGroupConfig } from '../../hooks/useBrandGroupConfig';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useTracking } from '../../hooks/useTracking';
import { EventActionValues, EventCategoryValues, EventLabelValues } from '../../types/tracking';

interface InvitationErrorGenericProps {
  trackingLabel?: EventLabelValues;
}

export function InvitationErrorGeneric({
  trackingLabel = EventLabelValues.InvitationErrorGeneric,
}: InvitationErrorGenericProps) {
  const { trackEventWithCategory } = useTracking();
  const brandGroupConfigHook = useBrandGroupConfig();
  const { brand } = useQueryParams();
  const brandConfig = brandGroupConfigHook.getBrandConfigFromBrandId(brand);
  const hasTrackedError = useRef(false);

  useEffect(() => {
    if (brand && !hasTrackedError.current) {
      trackEventWithCategory(EventActionValues.Show, trackingLabel, EventCategoryValues.Invitation);
      hasTrackedError.current = true;
    }
  }, [brand, trackingLabel, trackEventWithCategory]);

  const handleButtonClick = () => {
    trackEventWithCategory(EventActionValues.Click, trackingLabel, EventCategoryValues.Invitation);
    window.location.href = brandConfig?.urlDisplay ? `https://${brandConfig.urlDisplay}` : '#';
  };

  return (
    <>
      <Paragraph size="Paragraph" className="bold text-center mt-7 mb-3">
        {t('invitation.error.titleText')}
      </Paragraph>
      <Caption size="lg" className="text-center">
        {t('invitation.error.description', { brand: brandConfig?.name })}
      </Caption>
      <Button size="lg" appearance="primary" data-cy="errorButton" onClick={handleButtonClick}>
        {t('invitation.error.buttonText', { brand: brandConfig?.name })}
      </Button>
    </>
  );
}
